// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-time[data-v-dc57df5e]{display:flex;padding:.53333rem}.top-time>div[data-v-dc57df5e]{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center}.top-time>div>span[data-v-dc57df5e]{font-family:Inter-Regular}.top-time>div>span[data-v-dc57df5e]:first-child{font-size:.64rem;font-weight:600;color:#fff;line-height:.88rem}.top-time>div>span[data-v-dc57df5e]:nth-child(2){font-weight:400;font-size:.42667rem;color:hsla(0,0%,100%,.6)}", ""]);
// Exports
module.exports = exports;
